
import styled, { css } from "vue-styled-components";

const OverlayHover = css`
  opacity: 0.8;
  transition: all 0.3s ease;
  cursor: pointer;
  background-color: #00000012;
`;
const SectionNameHover = css`
color: #12A9FF;
background-color: #F4FCFF;
border: 1px solid #12A9FF;
`
const SectionNameFocus = css`
color: white;
background-color: #12A9FF;
border: 1px solid #12A9FF;
`
const SectionNameActive = css`
color: white;
background-color: #999999;
border: 1px solid #999999;
`
const OverlayActive = css`

  opacity: 1;
  transition: all 0.3s ease;
  background-color: unset;
`;
const OverlayProps = {
  active: Boolean,
}
const Overlay = styled('div', OverlayProps)`
  pointer-events: none;  
  position: absolute;
  width: 100%;
  height: 100%;
  border: 2px solid #12A9FF;
  transition: all 0.1s ease;
  opacity: 0;
  z-index: 3;
  `;
const Wrapper = styled.div`
  position: absolute;
  width: 100%;
    height: 100%;
    top: 0;
    left: 0;

  &.hover:not(.active) {
    & > .lbl-name, & > .add-section, & > .section-tool{
      opacity: 1;
      transition: all 0.3s ease;
    }
    & > .overlay {
      ${OverlayHover}
    }
    & > .lbl-name {
      ${SectionNameHover}
    }
   
  }
  &.hover, &.active {
    & > .lbl-name[lv="0"], & > .add-section,  & > .section-tool{
      opacity: 1;
      transition: all 0.3s ease;
    }
  }
  &.active {
    & > .lbl-name {
      ${SectionNameActive}
    }
    & > .add-section{
      opacity: 0;
      transition: all 0.1s ease;
    }

  }
  &.focus {
    & > .lbl-name {
      ${SectionNameFocus}
    }
    & > .add-section{
      opacity: 1;
      transition: all 0.1s ease;
    }

  }

  &.active {
    z-index: 1; // ถ้าต้องแก้เป็น index อื่นอีก แสดงว่าปัญหามันไม่จบสิ้นละ ต้องมาไล่ดู index ดีๆละ
    & * {
      pointer-events: all;
    }
    & > .overlay {
      cursor: pointer;
      ${OverlayActive}
      border: 2px solid #999999;
    }
  }
  &.focus {
    & > .overlay {
      cursor: default;
      border: 2px solid #12A9FF;
    }
  }
`;

const SectionName = styled.div`
  position: absolute;
  width: fit-content;
  padding: 5px;
  border-radius: 0px 5px 0px 0px;
  color: #12A9FF;
  left: 0;
  bottom: 100%;
  background-color: #F4FCFF;
  opacity: 0;
  z-index: 4;
  font-weight: 500;
  transition: all 0.1s ease;
  line-height: 1;
  font-size: 12px;
  border: 1px solid #12A9FF;

`;
const SectionTool = styled.div`
  position: absolute;
  width: fit-content;
  padding: 5px;
  border-radius: 0px 0px 0px 5px;
  right: 0;
  opacity: 1;
  z-index: 4;
  font-weight: 500;
  transition: all 0.1s ease;
  line-height: 1;
  font-size: 16px;
  margin-right: 4px;
  & > div {
    cursor: pointer;
    margin: 2px;
    border: 1px solid #DFDFDF;
    border-radius: 50%;
    background-color: white;
    color: var(--paragraph);
    font-size: 16px;
    line-height: 1;
    width: 28px;
    height: 28px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.075);
  }
`;
const AddSection = styled.div`
  &.top {
    top: calc( 30px / -2 );
  }
  &.bottom {
    bottom: calc( 30px / -2 );
  }
  opacity: 0;
  position: absolute;
  /* background-color: #12A9FF; */
  background-color: #397EF9;
  
  left: 0;
  right: 0;
  margin: auto;
  z-index: 4;
  width: 30px;
  height: 30px;
  cursor: pointer;
  border-radius: 50%;
`;

export {
  Overlay,
  Wrapper,
  SectionName,
  SectionTool,
  AddSection
}